export function Loading({ label = 'Loading calendar' }: { label?: string }) {
  return (
    <div className="loading" role="status">
      <span className="spinner" />
      {label}
    </div>
  );
}

export function ErrorMessage({ message, retry }: { message: string; retry?: () => void }) {
  return (
    <div className="error-card" role="alert">
      <div>
        <b>Something went wrong</b>
        <p>{message}</p>
      </div>
      {retry && (
        <button className="button button-small" onClick={retry}>
          Try again
        </button>
      )}
    </div>
  );
}
